export type questionType = 'multiple' | 'binary' | 'open' | 'detailed';

export interface IMinimizedQuestionProps {
    type: questionType;
    onDragEnd?: () => void;
    disabled?: boolean;
}

export const MIN_QUESTION_DRAG_TYPE = 'MIN_QUESTION_DRAG_TYPE';
